type Blocks = number[]
type CreditCardType = 'mastercard' | 'maestro' | 'mir' | 'visa'

const blocks: Blocks = [4, 4, 4, 4]
// регулярки карт взял от сюда
// https://github.com/nosir/cleave.js/blob/master/src/shortcuts/CreditCardDetector.js#L21
const re: Record<CreditCardType, RegExp> = {
  // starts with 51-55/2221–2720; 16 digits
  mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
  // starts with 50/56-58/6304/67; 16 digits
  maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
  // starts with 22; 16 digits
  mir: /^220[0-4]\d{0,12}/,
  // starts with 4; 16 digits
  visa: /^4[\d|*]{0,15}/,
}

const getType = (value: string, type?: string): string => {
  if (type) {
    return type
  }

  for (const key in re) {
    if (re[key].test(value)) {
      return type
    }
  }

  return 'unknown'
}

export const creditCardFormatter = (rawValue: string, mayBeType?: string): {type: string; value: string} => {
  const type = getType(rawValue, mayBeType)
  const value = blocks.reduce((acc, block, index) => {
    const start = index * block
    const end = start + block

    return `${acc} ${rawValue.substring(start, end)}`.trim()
  }, '')

  return {
    type,
    value,
  }
}

// дозаполним звездочками номер, если он короткий
export function toAsterisk(value: string): string {
  if (value.length < 16) {
    const position = value.indexOf('*')
    const stars = Array(16 - value.length + 1).join('*')

    return [value.slice(0, position), stars, value.slice(position)].join('')
  }

  return value
}

export function toSecureCardNumber(number: string = '0000000000000000', mayBeType?: string): string {
  return creditCardFormatter(toAsterisk(number), mayBeType).value
}

export function toExpirationDate(year: number | string = '****', month: number | string = '**'): string {
  return `${String(month).padStart(2, '0')} / ${year}`
}
